export default __webpack_public_path__ + "static/1-0dfaa292645f4445741ede25960d1762.jpeg";